import React, {useContext} from "react";
import { Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Dimmer, Loader } from "semantic-ui-react";

import { RootStoreContext } from "../stores/rootStore";
import { Role } from "../../app/util/role";
import NavBar from "../../features/nav/NavBar";



const ForAdmins = ({children}) => {
  const rootStore = useContext(RootStoreContext);
  const { isLoggedIn, relogUsers, user } = rootStore.userStore;

  if (!isLoggedIn) {
    relogUsers()
    return (
      <Dimmer active>
        <Loader content="Loading..." size="massive" />
      </Dimmer>
    );
  }

  if (user?.role !== Role.Admin) {
    return <Navigate to="/home/Dashboard" replace />;
  }

  return (
    <>
      <NavBar />
      {children}
    </>
  );
};

export default observer(ForAdmins);
